import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { Dispatch } from "redux";
import { State } from "redux/state";

import { ErrorBoundaryOwnProps, ErrorBoundaryStateProps, ErrorBoundaryView } from "../components/ErrorBoundaryView";

const mapDispatchToProps: MapDispatchToProps<{}, ErrorBoundaryOwnProps> = (dispatch: Dispatch) => {
    return {};
};

const mapStateToProps: MapStateToProps<ErrorBoundaryStateProps, ErrorBoundaryOwnProps, State> = (state: State) => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ErrorBoundaryView);
